import { Dispatch } from 'redux';

import { actionTypes } from './types';

type Action<T> = import('./types').Action<T>;

export interface ChangeLBSBankAction extends Action<typeof actionTypes.CHANGE_LBS_BANK> {
    type: typeof actionTypes.CHANGE_LBS_BANK;
    payload: {
        bankregnr: string;
    };
}

export interface ShowLBSBankSelectAction extends Action<typeof actionTypes.SHOW_LBS_SELECT> {
    type: typeof actionTypes.SHOW_LBS_SELECT;
    payload: {
        show: boolean;
    };
}

export type LBSActions = ChangeLBSBankAction | ShowLBSBankSelectAction;

export const changeLBSBankAction = (bankregnr: string): ChangeLBSBankAction => ({
    type: actionTypes.CHANGE_LBS_BANK,
    payload: { bankregnr },
});

export const showLBSBankSelect = (show: boolean): ShowLBSBankSelectAction => ({
    type: actionTypes.SHOW_LBS_SELECT,
    payload: { show },
});

export const changeLBSBank =
    (bankregnr: string) =>
    async (dispatch: Dispatch<LBSActions>): Promise<void> => {
        dispatch(changeLBSBankAction(bankregnr));
    };
